import { HomePageYourOpenPullRequestsCard } from '@roadiehq/backstage-plugin-github-pull-requests';
import type { CreateCardHomePageWidget } from './Home';

const OpenPullRequestsWidget = () => (
  <HomePageYourOpenPullRequestsCard hostname="schibsted.ghe.com" />
);

export const createOpenPullRequestsWidget = (
  createCardHomePageWidget: CreateCardHomePageWidget,
) =>
  createCardHomePageWidget({
    extensionId: 'backstage-plugin-github-pull-requests',
    widgetName: 'OpenPullRequests',
    title: 'Open Pull Requests',
    description: 'Your open pull requests across all repositories',
    Component: OpenPullRequestsWidget,
  });
